import {DTemplate} from './DTemplate.js';

export class MessageDisplay {
	constructor(parent, message) {
	  var parms = new URLSearchParams(window.location.search);
	  this.mod = parms.has("moder8or");
	  this.parent = parent;
	  this.message = message;
	  [this.el, this.$] = DTemplate(`MessageDisplay`);

	  let from = message.from;
	  if (veedoConfig && veedoConfig.has('strip_nickname_asterisk')) {
	  	if ('*'==from.substr(0,1)) {
	  		from = from.substr(1);
	  	}
	  }
	  this.$.from.innerText = from;
	  let t = message.text;
	  let mid = message.mid;
	  this.el.id = mid;
	  // console.log(`message.text = `, t);
	  // t = t.replaceAll(/</g, '&lt;');
	  // t = t.replaceAll(/>/g, '&gt;');
	  t = t.replace(/(https?:\/\/[^\s]+)?/gi, match=>{
	  	return `<a href="${match}" target="_blank">${match}</a>`;
	  });

	  if (!this.mod || mid == null || mid.length < 8){
		$(this.el).find(".del").remove();
	  }

	  this.$.text.innerHTML = t;
	  if (`undefined`==typeof message.date) message.date = new Date();
	  this.$.date.innerText = moment(message.date).format(`h:mm:ss`);
	  this.parent.appendChild(this.el);

	  this.$.del.addEventListener(`click`, (evt)=>{
		this.sendMessage(evt);
	  });

	}

	sendMessage(evt) {
		if ('function'==typeof evt.preventDefault){
			evt.preventDefault(); evt.stopPropagation();
		}
		const mid = this.el.id;
		if (mid != null && mid.length == 8){
			const text = `/remx ${mid}`;
			const input = {
				value: text
			};
	
			setTimeout(function() {
				if (``!=text && `function`==typeof window.SendChatMessageFromInput) {
					window.SendChatMessageFromInput(input);
				}	
			}, 0);
		}
	}
}
